<template>
  <div class="cover">
    <!-- <h4><span></span>ATLASCAP</h4> -->
    <div class="center"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      language: "getType"
    }),
    list() {
      return this.language == "中文"
        ? ["橙光", "诺信", "小佩", "52toys"]
        : ["66RPG", "Naxions", "PETKIT", "52Toys"];
    }
  }
};
</script>

<style lang="less" scoped>
.cover {
  width: 100%;
  height: 4.89rem;
  background: url("../../images/coverbg.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 1.27rem 0 0 0.44rem;
  h4 {
    font-size: 0.48rem;
    font-family: FZDeSaiHei515S-R-GB;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0.03rem 0.04rem 0.23rem rgba(0, 158, 48, 0.34);
    margin: 0 0.1rem;
    margin: 0;
    padding: 0;
    font-weight: 800;
    letter-spacing: 0.02rem;
    span {
      display: inline-block;
      width: 0.62rem;
      height: 1.02rem;
      background: url("../../images/icon1.png");
      background-size: 100% 100%;
      vertical-align: middle;
    }
  }
  .center {
    margin-left: 0.7rem;
  }
  .text {
    display: inline-block;
    margin: 0 0.05rem;
    font-size: 0.24rem;
    color: rgba(255, 255, 255, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/mycomoponet/cover.vue